import React from 'react';
import { Avatar, Box } from '@popmenu/common-ui';
import type { RootPlaceMenuItemQuery_rootPlace_RootPlace_menuItem_MenuItem_recentUserAvatars_UserAvatar as AvatarType } from '../../../libs/gql/queries/root_places/rootPlaceMenuItemQuery.generated';
import { makeStyles } from '../../../utils/withStyles';

const useStyles = makeStyles(theme => ({
  avatar: {
    '&:first-child': {
      marginLeft: '-2px',
    },
    border: `2px solid ${theme.palette.surface.light}`,
    float: 'left',
    height: theme.spacing(4),
    marginLeft: theme.spacing(-1.5),
    width: theme.spacing(4),
  },
  container: {
    marginBottom: theme.spacing(2),
    overflow: 'auto',
  },
}));

export const DishModalAvatars = ({ avatars }: { avatars: AvatarType[] }) => {
  const classes = useStyles();
  const sortedAvatars = avatars.slice().reverse();

  if (sortedAvatars.length === 0) {
    return null;
  }
  return (
    <Box className={classes.container}>
      {sortedAvatars.map(avatar => (
        <Avatar
          key={avatar.id}
          alt={avatar.displayName}
          className={classes.avatar}
          src={avatar.avatarUrl}
        />
      ))}
    </Box>
  );
};
